import { Identifiable, Notification } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State } from "./types";

function isRead(
  notification: Identifiable<Notification>,
  notifications: Identifiable<Notification>[],
) {
  return !!notifications.find(({ uuid }) => notification.uuid === uuid);
}

function handleMarkNotificationsAsRead(
  state: State,
  notifications: Boundaries["markNotificationsAsRead"]["success"],
): State {
  return {
    ...state,
    notifications: state.notifications.map((notification) => ({
      ...notification,
      isRead: isRead(notification, state.notifications),
    })),
  };
}

export { handleMarkNotificationsAsRead };
